import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import './style.scss';

type FixedScrollNavigationProps = {
  label: ReactNode;
  isLoading: string;
  onClick?: () => void;
  disabledInformation?: string | undefined;
};

const FixedScrollNavigation = ({ onClick, label, disabledInformation, isLoading }: FixedScrollNavigationProps) => (
  <div
    className={classNames('fixed-scroll-navigation', { 'cursor-disabled': disabledInformation || isLoading })}
    onClick={() => (disabledInformation || !onClick || isLoading ? null : onClick())}
    data-test-id="fixed-scroll-navigation"
  >
    <h6 className="headline">{label}</h6>
    {disabledInformation && (
      <p className="disabled-reason" data-test-id="disabled-reason">
        <FormattedMessage id={disabledInformation} />
      </p>
    )}
  </div>
);

export default FixedScrollNavigation;
